
import { supabase } from "@/integrations/supabase/client";

export async function uploadArticleImage(file: File): Promise<string | null> {
  try {
    const fileExt = file.name.split('.').pop();
    const fileName = `${Date.now()}.${fileExt}`;
    const filePath = `article-images/${fileName}`;

    const { error: uploadError } = await supabase.storage
      .from('articles')
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (uploadError) {
      throw uploadError;
    }

    const { data: urlData } = supabase.storage
      .from('articles')
      .getPublicUrl(filePath);

    return urlData.publicUrl;
  } catch (error: any) {
    throw new Error(`Failed to upload image: ${error.message || "Unknown error"}`);
  }
}
